angular.module('dpw.components')
  .directive('dpwErrorSwitch', [function() {
    return {
        restrict: 'A',
        transclude: true,
        scope: { 
            errorSwitchStatus: '@',
            errorMessage: '@'
        },
        controller: ['$scope', function($scope) {
            $scope.defaultErrorMessage = "Sorry, the content can't be displayed at this moment. Please try again later.";
        }],
        templateUrl: 'dpw-error-switch.html'
    }
  }]);